<svg xmlns="http://www.w3.org/2000/svg" width="14.8" height="14.8" viewBox="0 0 14.8 14.8">
  <g id="Group_1717" data-name="Group 1717" transform="translate(-16753.699 -5851.15)">
    <path id="Path_28" data-name="Path 28" d="M0,0H7.485V7.485" transform="translate(16761.807 5853.257) rotate(45)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.4"/>
    <line id="Line_11" data-name="Line 11" x1="8.485" y2="8.485" transform="translate(16761.1 5852.55) rotate(45)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.4"/>
  </g>
</svg>
